import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { IoIosArrowBack } from "react-icons/io";
import { MdOutlineHome } from "react-icons/md";

import { GeneralBtn } from "../../components/General";

const NonProtectedShared = () => {
  const navigate = useNavigate();

  //   Navigate to home page
  const handleToHomePage = () => {
    navigate("/");
  };

  //   Navigate to previous page
  const handleToPreviousPage = () => {
    navigate(-1);
  };

  //   Navigate to login page
  const handleToLogin = () => {
    navigate(`/register`);
  };

  return (
    <SharedWrapper>
      <header className="non__protected__header">
        <div className="header__btns__con">
          <GeneralBtn
            btnContent="Home"
            icon={<MdOutlineHome />}
            handleClick={handleToHomePage}
            btnConStyle="header__btn__container"
            btnStyle="header__btn__style"
          />
          <GeneralBtn
            btnContent="Go Back"
            icon={<IoIosArrowBack />}
            handleClick={handleToPreviousPage}
            btnConStyle="header__btn__container"
            btnStyle="header__btn__style"
          />
          <GeneralBtn
            btnContent="Login"
            handleClick={handleToLogin}
            btnConStyle="btn__container"
          />
        </div>
      </header>

      <div className="outlet__wrap">
        <Outlet />
      </div>
    </SharedWrapper>
  );
};

export default NonProtectedShared;

const SharedWrapper = styled.main`
  background: radial-gradient(
    circle at 100%,
    #e4d3bc,
    #e4d3bc 50%,
    #dcd7d1 75%,
    #e4d3bc 75%
  );
  padding-block: 2rem 3rem;
  min-height: 100vh;

  .non__protected__header {
    max-width: 1400px;
    margin-inline: auto;
    padding-inline: 1rem;
  }

  .header__btns__con {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 1rem;
  }

  .header__btn__container {
    /*  */
  }

  .header__btn__style {
    padding-right: 12px;
  }

  .outlet__wrap {
    max-width: 1500px;
    margin-inline: auto;
  }
`;
